module.exports = __webpack_public_path__ + "img/antes_despues_216.63f26d19.png";